module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "width": "1000px",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "flat": "",
      "absolute": "",
      "color": "primary",
      "width": "100%"
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.termsAndConditions.title[_vm.selectedLang]))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": _vm.disagree
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-title'), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.termsAndConditions.title[_vm.selectedLang]))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.termsAndConditions.html[_vm.selectedLang])
    }
  })])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-row', {
    staticStyle: {
      "margin-bottom": "10px !important"
    }
  }, [_c('v-col', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "cols": "12",
      "align": "right"
    }
  }, [_c('v-container', [_c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.agree
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-checkbox-marked-circle")]), _vm._v(_vm._s(_vm.termsAndConditions.confirmButtonText))], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": _vm.disagree
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v(" mdi-cancel")]), _vm._v(_vm._s(_vm.termsAndConditions.cancelButtonText))], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e600376"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/JoinCommunity/RateCardTermsModal.vue
// module id = 2029
// module chunks = 0